module.exports = __webpack_public_path__ + "img/btn_breast_on.28689f8b.svg";